import { ERoleType, EUserStatus, EOpenFactsCategory } from "enum";
import { enumToLabelValueList } from "./utils";
import { EOrderStatus } from "enum/EOrderStatus";
import { EContentReportSection, EContentReportStatus, EContentReportTarget } from "enum/EContentReport";

const TABLE_COLUMN_MIN_WIDTH = 100;
const TABLE_COLUMN_MAX_WIDTH = 300;
const FLEX = 1;

export const tableColumnProps = {
    minWidth: TABLE_COLUMN_MIN_WIDTH,
    // maxWidth: TABLE_COLUMN_MAX_WIDTH,
    flex: FLEX,
}

export const centerColumns = {
    headerAlign: 'center',
    align: 'center',
}

export const filterUserRolesList = enumToLabelValueList({
    ALL: 'all',
    ...ERoleType,
});

export const filterUserStatusList = enumToLabelValueList({
    ALL: 'all',
    ...EUserStatus,
});

export const filterOrdersStatusList = enumToLabelValueList({
    ALL: 'all',
    ...EOrderStatus,
});

export const filterContentReportStatusList = enumToLabelValueList({
    ALL: 'all',
    ...EContentReportStatus,
});

export const filterContentReportTargetList = enumToLabelValueList({
    ALL: 'all',
    ...EContentReportTarget,
});

export const filterContentReportSectionList = enumToLabelValueList({
    ALL: 'all',
    ...EContentReportSection,
});

export const filterOpenFactsCategoryList = enumToLabelValueList({
    ...EOpenFactsCategory,
});

export const currencies = {
    shekel: '₪',
}

// The same MapTiler streets map the mobile app draws stores on. The key is a
// client key and ships inside the app either way.
export const MAP_STYLE_URL = 'https://api.maptiler.com/maps/streets-v2/style.json?key=quodkwKxLp7r3yssQOLR';